import React from "react";
import video2 from "../assets/video/video2.mp4";
import video3 from "../assets/video/video3.mp4";
import video4 from "../assets/video/video4.mp4";
import video5 from "../assets/video/video5.mp4";
import video6 from "../assets/video/video6.mp4";
import video7 from "../assets/video/video7.mp4";
import video8 from "../assets/video/video8.mp4";
import video9 from "../assets/video/video9.mp4"; // Change filename if needed

function SchoolInfrastructure() {
  const data = [
    {
      id: 1,
      title: "Total Campus Area of the School (in sq. mtr)",
      value: "6117",
    },
    {
      id: 2,
      title: "No. and Size of the Class Rooms (in sq. mtr)",
      value: "54, 25×25",
    },
    {
      id: 3,
      title:
        "No. and Size of Laboratories including Computer Labs (in sq. mtr)",
      value: "2, 25×25",
    },
    {
      id: 4,
      title: "Internet Facility",
      value: "YES",
      highlight: true,
    },
    {
      id: 5,
      title: "No. of Girls Toilet",
      value: "24",
    },
    {
      id: 6,
      title: "No. of Boys Toilet",
      value: "24",
    },
  ];

  return (
    <section className="bg-gray-50 py-16 px-6">
      <div className="max-w-6xl mx-auto">

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-10 text-center">
          School Infrastructure
        </h2>

        {/* Table */}
        <div className="overflow-hidden rounded-2xl shadow-lg border mb-12">
          <table className="w-full text-left border-collapse">
            <thead className="bg-blue-900 text-white">
              <tr>
                <th className="px-6 py-4">Sl No</th>
                <th className="px-6 py-4">Information</th>
                <th className="px-6 py-4">Details</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) => (
                <tr
                  key={item.id}
                  className={`border-t ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-yellow-50 transition`}
                >
                  <td className="px-6 py-4 font-semibold text-blue-900">
                    {item.id}
                  </td>

                  <td className="px-6 py-4 font-medium text-gray-700">
                    {item.title}
                  </td>

                  <td className="px-6 py-4 text-gray-800">
                    {item.highlight ? (
                      <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full font-semibold">
                        {item.value}
                      </span>
                    ) : (
                      item.value
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Videos */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-blue-900 mb-8">
            School Videos
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

            {/* YouTube Video */}
            {/* <div className="aspect-video rounded-2xl overflow-hidden shadow-xl">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/JSm69j9KMog"
                title="School Infrastructure Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div> */}

            {/* Local MP4 Video */}
            {/* <div className="aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
              <video
                className="w-full h-full object-cover"
                controls
                preload="metadata"
              >
                <source src={video2} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div> */}

            <div className="aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
              <video
                className="w-full h-full object-cover"
                controls
                preload="metadata"
              >
                <source src={video3} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
              <video
                className="w-full h-full object-cover"
                controls
                preload="metadata"
              >
                <source src={video4} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
              <video
                className="w-full h-full object-cover"
                controls
                preload="metadata"
              >
                <source src={video5} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
              <video
                className="w-full h-full object-cover"
                controls
                preload="metadata"
              >
                <source src={video6} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
              <video
                className="w-full h-full object-cover"
                controls
                preload="metadata"
              >
                <source src={video7} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
              <video
                className="w-full h-full object-cover"
                controls
                preload="metadata"
              >
                <source src={video8} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="aspect-video rounded-2xl overflow-hidden shadow-xl bg-black">
              <video
                className="w-full h-full object-cover"
                controls
                preload="metadata"
              >
                <source src={video9} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}

export default SchoolInfrastructure;